{
  "titles": {
    "menu": "Medewerkers",
    "table": "Medewerkers",
    "create": "Medewerker aanmaken",
    "update": "Medewerker wijzigen"
  },
  "fields": {
    "labels": {
      "fullName": "Naam",
      "firstName": "Voornaam",
      "lastName": "Achternaam",
      "email": "E-mail",
      "isBlocked": "Gebruiker geblokkeerd",
      "roles": "Rollen",
      "failedLoginAttempts": "Mislukte/inlogpogingen",
      "loggedInAt": "Laatst ingelogd"
    },
    "hints": {

    },
    "validationErrors": {

    }
  },
  "headers": {
    "labels": {
        "name": "Naam",
        "email": "E-mail"
    }
  },
  "messages": {
    "createSuccess": "Medewerker aangemaakt",
    "updateSuccess": "Medewerker is opgeslagen"
  },
  "actions": {
    "create": "Medewerker aanmaken",
    "update": "Medewerker aanpassen",
    "search": "Zoek een medewerker"
  }
}
